import type { SavedFilterSection } from './index';

export const savedFiltersQueryKeys = {
  all: ['saved-filters'] as const,
  lists: () => [...savedFiltersQueryKeys.all, 'list'] as const,
  list: (section: SavedFilterSection, contextId?: number | null) =>
    [...savedFiltersQueryKeys.lists(), section, contextId ?? null] as const,
  details: () => [...savedFiltersQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...savedFiltersQueryKeys.details(), id] as const
};
